import { HaghighiHoghooghiEnum } from 'Feature/Common/Common/Types/Enums/HaghighiHoghooghiEnum';
import { JensiatEnum } from 'Feature/Common/Common/Types/Enums/JensiatEnum';

import IBimehShodehDto from '../../../Common/types/Commands/Sodoor/IBimehShodehDto';

const BimehShodehInitialState: IBimehShodehDto = {
  haghighiHoghooghi: HaghighiHoghooghiEnum.HAGHIGHI,
  isBimehgozar: false,
  melliatCoreId: '',
  codeMelli: '',
  isPardakhtKonandeh: false,
  naam: '',
  naamKhanevadegi: '',
  jensiat: JensiatEnum.MARD,
  tarikhTavalod: null,
  isTarafAsli: false,
  naamLatin: '',
  naamKhanevadegiLatin: '',
  codeRahgiriVisa: '',
  shomarehPassport: '',
  tarikhTavalodMiladi: null,
  shenasehMelliHoghooghi: null,
};

export default BimehShodehInitialState;
